import $ from "jquery";
import React, { Component } from "react";
import { Fields, reduxForm, formValueSelector, change } from "redux-form";
import { connect } from "react-redux";
import { Row, Column } from "react-foundation";

import Loading from "components/Loading";
import Tick from "components/Tick";

import { getWindowDimensionLimits } from "selectors/index";

import validate from "./validate";

import { getWindowDesigns } from "actions";
import InputError from "../../components/InputError";
import ThemeButton from "../../components/ThemeButton";
import SeparatingLine from "../../components/SeparatingLine";
import FormHeader from "../../components/FormHeader";
import FormWrapper from "../FormWrapper";
import { updatePreviousSelection } from "../../actions";

class SelectSize extends Component {
    handleChange(value) {
        for (let key in value) {
            this.props.WindowSize[key].input.onChange(value[key]);
        }
    }

    componentWillMount() {
        this.handleChange({
            Approximate: "medium",
            Type: "approximate",
            Width: null,
            Height: null
        });  
    }

    normalizeSize(onChange) {
        return e => {
            let val = e.target.value;
            // replace any non number character
            val = val.replace(/([^0-9.])/i, "");
            // remove any period after the first one
            val = val.replace(
                /\./g,
                (char, index, str) => (str.indexOf(char) === index ? char : "")
            );
            // remove any char after 2 dp
            val = val.replace(/(\.\d{0,2})\d*/, "$1");

            onChange(val);
        };
    }

    render() {
        let {
            loading,
            WindowSize: { Width, Height, Unit, Approximate, Type }
        } = this.props;

        if (loading) {
            return <Loading />;
        }

        return (
            <div className="size-fields-container">
                <Row>
                    <Column
                        large={5}
                        // pushOnLarge={7}
                        className={
                            "approximate" + (Type.input.value === "approximate" ? " selected" : "")
                        }
                    >
                        <Row isColumn className="size-type">
                            Approximate Sizes
                        </Row>
                        <Row isColumn>
                            <div className="approximate-title-container">
                                <span className="size-small">Small</span>
                                <span className="size-medium">Medium</span>
                                <span className="size-large">Large</span>
                            </div>
                        </Row>
                        <Row isColumn>
                            <div className="approximate-size-container">
                                <div
                                    className="size-small"
                                    onClick={() =>
                                        this.handleChange({
                                            Approximate: "small",
                                            Type: "approximate",
                                            Width: "",
                                            Height: ""
                                        })
                                    }
                                >
                                    {Approximate.input.value === "small" && <Tick />}
                                </div>
                                <div
                                    className="size-medium"
                                    onClick={() =>
                                        this.handleChange({
                                            Approximate: "medium",
                                            Type: "approximate",
                                            Width: null,
                                            Height: null
                                        })
                                    }
                                >
                                    {Approximate.input.value === "medium" && <Tick />}
                                </div>
                                <div
                                    className="size-large"
                                    onClick={() =>
                                        this.handleChange({
                                            Approximate: "large",
                                            Type: "approximate",
                                            Width: null,
                                            Height: null
                                        })
                                    }
                                >
                                    {Approximate.input.value === "large" && <Tick />}
                                </div>
                            </div>
                        </Row>
                    </Column>
                    <Column large={2}>
                        <div className="splitter" />
                    </Column>
                    <Column
                        large={4}
                        // pullOnLarge={6}
                        className={
                            "specific unit-selector-col" + (Type.input.value === "specific" ? " selected" : "")
                        }
                    >
                        <Row isColumn className="size-type">
                            Specific Sizes
                        </Row>
                        <Row collapseOnSmall className={'unit-selector-row'}>
                            <Column small={12} hideFor={"medium"} className="unit-selector">
                                <span
                                    onClick={() =>
                                        this.handleChange({
                                            Unit: "mm",
                                            Type: "specific",
                                            Approximate: null
                                        })
                                    }
                                    className={Unit.input.value === "mm" ? "selected" : ""}
                                >
                                    mm
                                </span>
                                <span
                                    onClick={() =>
                                        this.handleChange({
                                            Unit: "inch",
                                            Type: "specific",
                                            Approximate: null
                                        })
                                    }
                                    className={Unit.input.value === "inch" ? "selected" : ""}
                                >
                                    inch
                                </span>
                            </Column>
                            <Column small={12} medium={12}>
                                <div className="size-dimension-container">
                                    <input
                                        type="text"
                                        {...Height.input}
                                        onChange={this.normalizeSize(Height.input.onChange)}
                                        onBlur={() =>
                                            this.handleChange({
                                                Type: "specific",
                                                Approximate: null
                                            })
                                        }
                                        className="height"
                                    />
                                    <input
                                        type="text"
                                        {...Width.input}
                                        onChange={this.normalizeSize(Width.input.onChange)}
                                        onBlur={() =>
                                            this.handleChange({
                                                Type: "specific",
                                                Approximate: null
                                            })
                                        }
                                        className="width"
                                    />
                                </div>
                            </Column>
                            <Column medium={12} hideOnlyFor={"small"} className="unit-selector">
                                <span
                                    onClick={() =>
                                        this.handleChange({
                                            Unit: "mm",
                                            Type: "specific",
                                            Approximate: null
                                        })
                                    }
                                    className={Unit.input.value === "mm" ? "selected" : ""}
                                >
                                    mm
                                </span>
                                <span
                                    onClick={() =>
                                        this.handleChange({
                                            Unit: "inch",
                                            Type: "specific",
                                            Approximate: null
                                        })
                                    }
                                    className={Unit.input.value === "inch" ? "selected" : ""}
                                >
                                    inch
                                </span>
                            </Column>
                        </Row>
                    </Column>
                    <Column>
                        <InputError metas={[Width.meta, Height.meta, Type.meta]} />
                    </Column>
                </Row>
            </div>
        );
    }
}

class SizeForm extends Component {
    componentDidMount() {
        this.props.getWindowDesigns(this.props.windowStyleId);
    }

    componentDidUpdate() {
        let { designs, dispatch, previousSelection, windowSize } = this.props;

        if (designs.length > 0) {
            // default width
            if (previousSelection.WindowSizeWidth && !windowSize.Width)
                dispatch(
                    change("WindowWizard", "WindowSize.Width", previousSelection.WindowSizeWidth)
                );
            // default Height
            if (previousSelection.WindowSizeHeight && !windowSize.Height)
                dispatch(
                    change("WindowWizard", "WindowSize.Height", previousSelection.WindowSizeHeight)
                );
            // default Unit
            if (previousSelection.WindowSizeUnit && !windowSize.Unit)
                dispatch(
                    change("WindowWizard", "WindowSize.Unit", previousSelection.WindowSizeUnit)
                );
            // default Approximate
            if (previousSelection.WindowSizeApproximate && !windowSize.Approximate)
                dispatch(
                    change(
                        "WindowWizard",
                        "WindowSize.Approximate",
                        previousSelection.WindowSizeApproximate
                    )
                );
            // default Type
            if (previousSelection.WindowSizeType && !windowSize.Type)
                dispatch(
                    change("WindowWizard", "WindowSize.Type", previousSelection.WindowSizeType)
                );
        }
    }

    onSubmit(values) {
        this.props.updatePreviousSelection({
            WindowSizeWidth: values.WindowSize.Width,
            WindowSizeHeight: values.WindowSize.Height,
            WindowSizeUnit: values.WindowSize.Unit,
            WindowSizeApproximate: values.WindowSize.Approximate,
            WindowSizeType: values.WindowSize.Type
        });

        this.props.onSubmit(values);
    }

    render() {
        return (
            <form onSubmit={this.props.handleSubmit(this.onSubmit.bind(this))} className="SizeForm">
                <FormHeader
                    title={"Window Sizes"}
                    subtitle={
                        "Got your dimensions to hand? Don't worry if not, just select an approximate size option."
                    }
                />

                <SeparatingLine />

                <FormWrapper>
                    <Fields
                        names={[
                            "WindowSize.Width",
                            "WindowSize.Height",
                            "WindowSize.Unit",
                            "WindowSize.Approximate",
                            "WindowSize.Type"
                        ]}
                        component={SelectSize}
                        loading={this.props.loading}
                    />
                </FormWrapper>
                <div className="button-panel">
                    <SeparatingLine />
                    <button className="button back" type="button" onClick={this.props.previousPage}>
                        Back
                    </button>
                    <ThemeButton className="next">Next</ThemeButton>
                </div>
            </form>
        );
    }
}

const mapStateToProps = state => {
    let valueSelector = formValueSelector("WindowWizard");
    let windowStyleId = valueSelector(state, "WindowStyleId") || 7;

    let windowSize = valueSelector(state, "WindowSize");

    var dimensionLimits = getWindowDimensionLimits(state);

    return {
        dimensionLimits,
        windowStyleId,
        windowSize,
        loading: $.isEmptyObject(state.Window.Designs),

        designs: state.Window.Designs,
        previousSelection: state.PreviousSelection
    };
};

export default connect(
    mapStateToProps,
    { getWindowDesigns, updatePreviousSelection }
)(
    reduxForm({
        form: "WindowWizard",
        destroyOnUnmount: false,
        keepDirtyOnReinitialize: true,
        enableReinitialize: true,
        validate,
        initialValues: {
            WindowSize: {
                Unit: "mm",
                Type: "specific"
            }
        }
    })(SizeForm)
);



// WEBPACK FOOTER //
// ./src/containers/WindowForm/SizeForm.js